interface LocationLike {
  hash: string;
  pathname: string;
  search: string;
}

interface HistoryLike {
  state: unknown;
  replaceState(data: unknown, unused: string, url?: string | URL | null): void;
}

/**
 * Return a magic-link token once and immediately remove the entire fragment
 * from the current history entry. Tokens have a fixed base64url shape; reject
 * everything else without ever copying it into another URL.
 */
export function takeMagicToken(location: LocationLike, history: HistoryLike): string | null {
  if (!location.hash) return null;

  const params = new URLSearchParams(location.hash.slice(1));
  const token = params.get('magic_token');
  if (token === null) return null;

  history.replaceState(history.state, '', `${location.pathname}${location.search}`);
  return /^[A-Za-z0-9_-]{43}$/.test(token) ? token : null;
}
